import { createFileRoute, useParams } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { ContactDetailsPage } from "./contacts/-pages/contactDetails";
import { z } from "zod";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { sanitizeDocumentTitlePart, useDocumentTitle } from "~/utils/document-title";

const contactDetailSearchSchema = z.object({
  view: z.enum(["details", "notes", "communications", "documents", "chat-projects"]).optional().default("details"),
});

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/contacts/$contactId")({
  validateSearch: contactDetailSearchSchema,
  loader: async ({ params }) => {
    const contact = await queryClient.fetchQuery(trpc.contacts.getById.queryOptions({ id: params.contactId }));
    return { contact };
  },
  component: ContactDetailsRoute,
});

function ContactDetailsRoute() {
  const { contact } = Route.useLoaderData();
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  const contactName = sanitizeDocumentTitlePart(
    contact?.full_name ||
      [contact?.first_name, contact?.last_name].filter(Boolean).join(" ") ||
      contact?.emails?.[0]?.value,
    "Contact",
  );
  useDocumentTitle(contactName, "Contact");

  useBreadCrumbs([
    { title: "Contacts", link: `/${datasetSlug}/data/contacts` },
    { title: contactName, link: `/${datasetSlug}/data/contacts/${contact?.id}` },
  ]);

  return <ContactDetailsPage contact={contact} />;
}
